export default __webpack_public_path__ + "static/media/Order_Step_2.4610982a.svg";